<template>
  <v-autocomplete
      v-model="period"
      :items="periods"
      item-value="id"
      item-text="name"
      label="Период"
      prepend-inner-icon="mdi mdi-reload mdi-18px"
      no-filter
      :rules="rule"
      @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span class="mr-2 mt-n1" style="max-width: 150px;">
        <v-chip small v-if="period !== ''">
          <span>{{ periods.find(p => p.id === period).name }}</span>
        </v-chip>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'PeriodSelector',
  props: {
    value: {
      required: true,
    },
    noRules: Boolean,
  },

  data() {
    return {
      periods: [
        {id: 'today', name: 'Сегодня',},
        {id: 'yesterday', name: 'Вчера',},
        {id: 'currWeek', name: 'Текущая неделя',},
        {id: 'prevWeek', name: 'Предыдущая неделя',},
        {id: 'currMonth', name: 'Текущий месяц',},
        {id: 'prevMonth', name: 'Предыдущий месяц',},
      ],
      rule: [
        v => {
          if (this.noRules) return true
          else {
            return !!v.length || 'Данное поле обязательно'
          }
        }
      ],
    }
  },

  computed: {
    ...mapGetters({}),

    period: {
      get() {
        return this.value;
      },
      set(period) {
        this.$emit("input", period);
      },
    },
  },

  watch: {},

  methods: {
    ...mapActions({}),

    refresh() {
      this.period = '';
    },
  },

  async mounted() {

  },
}
</script>

<style scoped lang="scss">
.sliced-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>